<template>
  <div class="columns">
    <div class="column is-half">
      <span class="is-pulled-right">
        <button
          type="button"
          class="button is-success"
          :class="{ 'is-loading': saveBusy }"
          :disabled="!template_text || saveBusy"
          @click.prevent.stop="onSaveTemplate"
        >
          <span class="icon">
            <i class="fa fa-floppy-o"></i>
          </span>
          <span>SAVE</span>
        </button>
      </span>

      <h1 class="is-size-2">Template</h1>

      <b-field label="Name">
        <b-input v-model="template_name" size="is-small" />
      </b-field>
      <template-editor :template.sync="template_text"></template-editor>
    </div>

    <div class="column">
      <h1 class="is-size-2">Preview</h1>

      <template-preview
        :template="template_text"
        profile="order"
        ref="templatePreview"
      ></template-preview>
    </div>
  </div>
</template>

<script>
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer.js";
import { TemplateService } from "@/services/template.service.js";
import TemplateEditor from "@/components/Template/TemplateEditor.vue";
import TemplatePreview from "@/components/Template/TemplatePreview.vue";

export default {
  components: {
    TemplateEditor: TemplateEditor,
    TemplatePreview: TemplatePreview
  },
  data() {
    return {
      saveBusy: false,
      template_name: "",
      template_text: ""
    };
  },
  methods: {
    onSaveTemplate() {
      const vm = this;
      const payload = {
        name: vm.template_name,
        type: "order", // temporary
        content: vm.template_text
      };
      const p = TemplateService.create(payload);

      vm.saveBusy = true;

      return p
        .then(response => {
          const template = JsonDenormalizer.denormalize(response);
          vm.template = template;
          vm.$router.replace({ name: "configuration.templates" });
        })
        .catch(err => {
          vm.$buefy.toast.open({
            type: "is-danger",
            message: "Failed to fetch template."
          });
        })
        .finally(() => {
          vm.saveBusy = false;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Templates/create.vue